import { render, staticRenderFns } from "./likeInfo.vue?vue&type=template&id=2dbb27ec&scoped=true&"
import script from "./likeInfo.vue?vue&type=script&lang=js&"
export * from "./likeInfo.vue?vue&type=script&lang=js&"
import style0 from "./likeInfo.vue?vue&type=style&index=0&id=2dbb27ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb27ec",
  null
  
)

export default component.exports